import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    container: {
        padding: 10,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 15,
        color: '#1e40af',
        borderBottomWidth: 1,
        borderBottomColor: '#e0e0e0',
        paddingBottom: 5,
    },
    chartContainer: {
        alignItems: 'center',
        marginBottom: 20,
    },
    chartImage: {
        width: 400,
        height: 400,
        marginBottom: 15,
    },
    chartPlaceholder: {
        width: 400,
        height: 400,
        backgroundColor: '#f3f4f6',
        borderWidth: 2,
        borderColor: '#d1d5db',
        borderStyle: 'dashed',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 15,
    },
    placeholderText: {
        fontSize: 14,
        color: '#6b7280',
        textAlign: 'center',
    },
    legendContainer: {
        marginTop: 15,
        padding: 10,
        backgroundColor: '#f9fafb',
        borderRadius: 5,
    },
    legendTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 10,
        color: '#374151',
    },
    legendItem: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 5,
    },
    legendColor: {
        width: 15,
        height: 15,
        marginRight: 8,
        borderRadius: 2,
    },
    legendText: {
        fontSize: 10,
        color: '#374151',
    },
    parametersContainer: {
        marginTop: 15,
        padding: 10,
        backgroundColor: '#f0f9ff',
        borderRadius: 5,
    },
    parametersTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        marginBottom: 10,
        color: '#1e40af',
    },
    parametersList: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    parameterItem: {
        width: '50%',
        fontSize: 9,
        color: '#374151',
        marginBottom: 3,
    },
    description: {
        fontSize: 11,
        color: '#6b7280',
        marginBottom: 15,
        lineHeight: 1.4,
    },
});

interface SpiderChartPDFProps {
    data?: {
        labels?: string[];
        datasets?: Array<{
            label: string;
            data: number[];
            backgroundColor: string;
            borderColor: string;
        }>;
    };
    chartImageUrl?: string; // Optional: if you can generate a chart image
}

export const SpiderChartPDF: React.FC<SpiderChartPDFProps> = ({ data, chartImageUrl }) => {
    // Color mapping for legend (matching the spider chart colors)
    const colorMapping = [
        { color: '#000000', label: 'Current Project' },
        { color: '#FF0000', label: 'Option 1' },
        { color: '#00FF00', label: 'Option 2' },
        { color: '#0000FF', label: 'Option 3' },
        { color: '#FFFF00', label: 'Option 4' },
        { color: '#00FFFF', label: 'Option 5' },
        { color: '#FF00FF', label: 'Option 6' },
        { color: '#C0C0C0', label: 'Option 7' },
        { color: '#808080', label: 'Option 8' },
        { color: '#800000', label: 'Option 9' },
    ];

    const datasets = data?.datasets || [];

    return (
        <View style={styles.container}>
            <Text style={styles.sectionTitle}>Similarity Comparison Chart</Text>

            {/* <Text style={styles.description}>
                This radar chart compares the current project parameters with similar cases from the database.
                Each axis represents a different parameter, and the distance from the center indicates the
                similarity percentage (0% at center, 100% at outer edge).
            </Text> */}

            <View style={styles.chartContainer}>
                {chartImageUrl ? (
                    <Image src={chartImageUrl} style={styles.chartImage} />
                ) : (
                    <View style={styles.chartPlaceholder}>
                        <Text style={styles.placeholderText}>
                            Spider Chart Visualization{'\n'}
                            (Chart would be displayed here in the actual application)
                        </Text>
                    </View>
                )}
            </View>

            {/* Legend */}
            {datasets.length > 0 && (
                <View style={styles.legendContainer}>
                    <Text style={styles.legendTitle}>Legend</Text>
                    {datasets.slice(0, 10).map((dataset, index) => (
                        <View key={index} style={styles.legendItem}>
                            <View
                                style={[
                                    styles.legendColor,
                                    { backgroundColor: dataset.borderColor || colorMapping[index]?.color || '#000000' }
                                ]}
                            />
                            <Text style={styles.legendText}>
                                {dataset.label || colorMapping[index]?.label || `Option ${index + 1}`}
                            </Text>
                        </View>
                    ))}
                </View>
            )}
        </View>
    );
}; 